import { ReactNode } from "react";
import "./page-title.sass";

type Props = {
  children: ReactNode;
  className?: string;
};

const PageTitle = ({ children, className = "" }: Props) => {
  return <div className={`page-title ${className}`}>{children}</div>;
};

export default PageTitle;
